import { c as _c } from "react/compiler-runtime";
import { NavLink } from 'react-router-dom';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';
import { useDesignSteps, type DesignStep, type DesignStepId } from './hooks/use-design-steps';
const tileClassName = (step: DesignStep, isCurrent: boolean) => cn('flex flex-[1_1_140px] flex-col gap-1 rounded-md border border-border bg-card px-3 py-2.5 text-foreground no-underline transition-colors max-md:flex-[0_0_150px]', step.kind === 'result' && 'border-dashed', isCurrent && 'border-solid border-ptl-rule-strong bg-accent shadow-[inset_0_0_0_1px_var(--ptl-rule-strong)]', !isCurrent && step.isAvailable && 'hover:border-input', !step.isAvailable && 'cursor-not-allowed opacity-60');

/**
 * Where the design stands, on every page of it.
 *
 * Four parameters and two results, each showing its current setting: the
 * reader sees the whole design from whichever page they are on, which is what
 * turns four pages into one form. A result tile stays dashed and inert until
 * there is a design to show.
 */
export const DesignStepsBar = t0 => {
  const $ = _c(10);
  const {
    currentStepId
  } = t0;
  const {
    t
  } = useTranslation();
  const steps = useDesignSteps();
  let t1;
  if ($[0] !== t) {
    t1 = t("Your design");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentStepId || $[3] !== steps) {
    let t3;
    if ($[5] !== currentStepId) {
      t3 = step => {
        const isCurrent = step.id === currentStepId;
        const content = <><span className="ptl-label">{step.label}</span><span className="min-h-[2lh] font-mono text-[12.5px] text-foreground">{step.value}</span></>;
        return step.isAvailable ? <NavLink key={step.id} to={step.to} aria-current={isCurrent ? "page" : undefined} className={tileClassName(step, isCurrent)}>{content}</NavLink> : <span key={step.id} aria-disabled="true" className={tileClassName(step, false)}>{content}</span>;
      };
      $[5] = currentStepId;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = steps.map(t3);
    $[2] = currentStepId;
    $[3] = steps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <nav aria-label={t1} className="flex flex-wrap items-stretch gap-2 max-md:-mx-4 max-md:flex-nowrap max-md:overflow-x-auto max-md:px-4 max-md:pb-1 print:hidden">{t2}</nav>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};